var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_group",
    "data-name": "Layer group",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2732 2048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d7d7d7;\n      }\n\n      .cls-2 {\n        fill: #888;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector_layer",
    "data-name": "Vector layer"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1298.65,994.81l-502.26,895.12h.86l-.61.34,86.74,151.51,137.87-77.18-42.75-74.66h130.53l611.97-895.03h.25L1109.2,99.81h-154.27l14.1-15.05L884.1,6.29l-87.53,93.34.18.18h-.18l502.23,895h-.15Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Vector_layer-2",
    "data-name": "Vector layer"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1455.04,1023.95l-571.15,1017.88h355.51l695.91-1017.79h.31L1239.64,6.17h-355.51l571.09,1017.79h-.18Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightButton);
export default __webpack_public_path__ + "static/media/Right_Button.fdc888f6027894799458534a60e58e1a.svg";
export { ForwardRef as ReactComponent };